export const TwitchConfig = {
  channel: (new URLSearchParams(window.location.search)).get('channel'),
  username: process.env.BOT_USERNAME,
  token: process.env.BOT_OAUTH_TOKEN,
};
